import { jsx as _jsx } from "react/jsx-runtime";
import { Box, useBreakpointValue } from '@gemini/core';
import { OFFER_CARD_HEIGHT, OFFER_CARD_MAX_WIDTH, OFFER_CARD_MIN_WIDTH, OFFER_CARD_MOST_POPULAR_HEIGHT, OFFER_CARD_MOST_POPULAR_LABEL_HEIGHT, } from './constants';
export function OfferCardContainerDesktop({ children, isMostPopular, }) {
    const breakpoint = useBreakpointValue({
        base: 'base',
        lg: 'lg',
        xl: 'xl',
    });
    const cardHeight = isMostPopular
        ? OFFER_CARD_MOST_POPULAR_HEIGHT
        : OFFER_CARD_HEIGHT;
    const marginTop = isMostPopular
        ? 'spacing.none'
        : OFFER_CARD_MOST_POPULAR_LABEL_HEIGHT;
    const minWidth = breakpoint === 'lg' ? OFFER_CARD_MIN_WIDTH : OFFER_CARD_MAX_WIDTH;
    return (_jsx(Box, { testId: "offer-card-container-desktop", minHeight: cardHeight, maxWidth: OFFER_CARD_MAX_WIDTH, minWidth: minWidth, borderRadius: "radius.16", display: "flex", flexDirection: "column", borderWidth: "borderWidth.1", borderStyle: "solid", borderColor: "color.border.light.default", justifyContent: "stretch", marginTop: marginTop, children: children }));
}
